// extracted by mini-css-extract-plugin
module.exports = {"tableHeader":"style_tableHeader__XgkzK"};